import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, View, Keyboard, ViewPropTypes } from 'react-native';
import Composer from './Composer';
import Send from './Send';
import Actions from './Actions';
import Color from './Color';
var styles = StyleSheet.create({
  container: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: Color.defaultColor,
    backgroundColor: Color.white,
    bottom: 0,
    left: 0,
    right: 0
  },
  primary: {
    flexDirection: 'row',
    alignItems: 'flex-end'
  },
  accessory: {
    height: 44
  }
});

var InputToolbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputToolbar, _React$Component);

  function InputToolbar() {
    var _this;

    _classCallCheck(this, InputToolbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputToolbar).apply(this, arguments));
    _this.state = {
      position: 'absolute'
    };
    _this.keyboardWillShowListener = undefined;
    _this.keyboardWillHideListener = undefined;

    _this.keyboardWillShow = function () {
      if (_this.state.position !== 'relative') {
        _this.setState({
          position: 'relative'
        });
      }
    };

    _this.keyboardWillHide = function () {
      if (_this.state.position !== 'absolute') {
        _this.setState({
          position: 'absolute'
        });
      }
    };

    return _this;
  }

  _createClass(InputToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.keyboardWillShowListener = Keyboard.addListener('keyboardWillShow', this.keyboardWillShow);
      this.keyboardWillHideListener = Keyboard.addListener('keyboardWillHide', this.keyboardWillHide);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.keyboardWillShowListener) {
        this.keyboardWillShowListener.remove();
      }

      if (this.keyboardWillHideListener) {
        this.keyboardWillHideListener.remove();
      }
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this$props = this.props,
          containerStyle = _this$props.containerStyle,
          props = _objectWithoutProperties(_this$props, ["containerStyle"]);

      if (this.props.renderActions) {
        return this.props.renderActions(props);
      } else if (this.props.onPressActionButton) {
        return React.createElement(Actions, props);
      }

      return null;
    }
  }, {
    key: "renderSend",
    value: function renderSend() {
      if (this.props.renderSend) {
        return this.props.renderSend(this.props);
      }

      return React.createElement(Send, this.props);
    }
  }, {
    key: "renderComposer",
    value: function renderComposer() {
      if (this.props.renderComposer) {
        return this.props.renderComposer(this.props);
      }

      return React.createElement(Composer, this.props);
    }
  }, {
    key: "renderAccessory",
    value: function renderAccessory() {
      if (this.props.renderAccessory) {
        return React.createElement(View, {
          style: [styles.accessory, this.props.accessoryStyle]
        }, this.props.renderAccessory(this.props));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(View, {
        style: [styles.container, this.props.containerStyle, {
          position: this.state.position
        }]
      }, React.createElement(View, {
        style: [styles.primary, this.props.primaryStyle]
      }, this.renderActions(), this.renderComposer(), this.renderSend()), this.renderAccessory());
    }
  }]);

  return InputToolbar;
}(React.Component);

export { InputToolbar as default };
InputToolbar.defaultProps = {
  renderAccessory: null,
  renderActions: null,
  renderSend: null,
  renderComposer: null,
  containerStyle: {},
  primaryStyle: {},
  accessoryStyle: {},
  onPressActionButton: function onPressActionButton() {}
};
InputToolbar.propTypes = {
  renderAccessory: PropTypes.func,
  renderActions: PropTypes.func,
  renderSend: PropTypes.func,
  renderComposer: PropTypes.func,
  onPressActionButton: PropTypes.func,
  containerStyle: ViewPropTypes.style,
  primaryStyle: ViewPropTypes.style,
  accessoryStyle: ViewPropTypes.style
};